// Loaded as its own asset rather than via {% javascript %}: the compiled
// section bundle currently fails to parse, which silently kills every
// section script on the page.
//
// Tabs are Tab theme blocks (blocks/product-tab.liquid). Each block renders
// its own button (the section cannot read a theme block's title) next to its
// panel; this moves the buttons into the section's tab bar in block order.
// Buttons and panels are matched by block id (data-tab / data-pane).
function productTabsActivate(root, id) {
  root.querySelectorAll('[data-tab-button]').forEach(function (btn) {
    var on = btn.getAttribute('data-tab') === id;
    btn.classList.toggle('active', on);
    btn.setAttribute('aria-selected', String(on));
    btn.tabIndex = on ? 0 : -1;
  });
  root.querySelectorAll('.tab-pane').forEach(function (pane) {
    pane.classList.toggle('active', pane.getAttribute('data-pane') === id);
  });
  // App widgets in a tab (review carousels and grids above all) measure
  // themselves when they load. In a hidden tab that is zero width, and they
  // stay collapsed after the tab opens; a resize makes them lay out again.
  window.requestAnimationFrame(function () {
    window.dispatchEvent(new Event('resize'));
  });
}

function initProductTabs(scope) {
  (scope || document).querySelectorAll('.product-tabs').forEach(function (root) {
    var list = root.querySelector('[data-tabs-list]');
    if (!list) return;

    // Empty tabs are left out on the storefront; with none left, hide the bar.
    root.hidden = !root.querySelector('[data-tab-button]');

    // Move any button still sitting beside its panel into the bar (all of them
    // on load; new ones after the editor re-renders a block).
    root.querySelectorAll('.tabs-content [data-tab-button]').forEach(function (btn) {
      list.appendChild(btn);
    });
    // Keep the bar in block order and drop buttons whose panel is gone.
    var panes = [].slice.call(root.querySelectorAll('.tab-pane'));
    var buttons = [].slice.call(list.querySelectorAll('[data-tab-button]'));
    buttons.forEach(function (btn) {
      if (!root.querySelector('.tab-pane[data-pane="' + btn.getAttribute('data-tab') + '"]')) btn.remove();
    });
    panes.forEach(function (pane) {
      var btn = list.querySelector('[data-tab="' + pane.getAttribute('data-pane') + '"]');
      if (btn) list.appendChild(btn);
    });

    if (root.dataset.tabsReady !== 'true') {
      root.dataset.tabsReady = 'true';
      var preferred = list.querySelector('[data-tab-default]') || list.querySelector('[data-tab-button].active') || list.querySelector('[data-tab-button]');
      if (preferred) productTabsActivate(root, preferred.getAttribute('data-tab'));

      list.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-tab-button]');
        if (btn) productTabsActivate(root, btn.getAttribute('data-tab'));
      });
      list.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        var btn = event.target.closest('[data-tab-button]');
        if (!btn) return;
        event.preventDefault();
        var all = [].slice.call(list.querySelectorAll('[data-tab-button]'));
        var step = event.key === 'ArrowRight' ? 1 : -1;
        var next = all[(all.indexOf(btn) + step + all.length) % all.length];
        next.focus();
        productTabsActivate(root, next.getAttribute('data-tab'));
      });
    } else {
      var active = list.querySelector('[data-tab-button].active') || list.querySelector('[data-tab-button]');
      if (active) productTabsActivate(root, active.getAttribute('data-tab'));
    }
  });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initProductTabs(); });
else initProductTabs();

// Theme editor: re-renders and block changes.
document.addEventListener('shopify:section:load', function (event) { initProductTabs(event.target); });
['shopify:block:select', 'shopify:section:reorder'].forEach(function (type) {
  document.addEventListener(type, function (event) {
    var pane = event.target.closest && event.target.closest('.tab-pane');
    // Nested app blocks do not always dispatch from inside their tab; find the
    // selected block by the id the editor sends and take its tab from there.
    if (!pane && event.detail && event.detail.blockId) {
      var selected = document.getElementById('shopify-block-' + event.detail.blockId) ||
        document.querySelector('[data-shopify-editor-block*="' + event.detail.blockId + '"]');
      pane = selected && selected.closest('.tab-pane');
    }
    var root = (pane && pane.closest('.product-tabs')) || (event.target.closest && event.target.closest('.product-tabs'));
    if (!root) return;
    initProductTabs(root.parentNode || document);
    if (pane) productTabsActivate(root, pane.getAttribute('data-pane'));
  });
});
